export const useCertifications = () => {
  const certifications = [
    { title: '• Programação de algoritmos escaláveis', issuer: 'Estácio', date: '26/04/2024' },
    { title: 'Programação de sistemas de informação', issuer: 'Estácio', date: '26/04/2024' },
    { title: 'Programação para dispositivos móveis', issuer: 'Estácio', date: '26/04/2024' },
    { title: 'Programação para internet', issuer: 'Estácio', date: '26/04/2024' },
  ];

  return { title: 'Certificações', certifications };
};
